module.exports = require("ws");